function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
var _ExternalResolvedDataHandler_brand = /*#__PURE__*/new WeakSet();
export class ExternalResolvedDataHandler extends AbstractExternalAPIHandler {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _ExternalResolvedDataHandler_brand);
  }
  getVectorArtResolvedData(data) {
    if (!_assertClassBrand(_ExternalResolvedDataHandler_brand, this, _hasUriProperty).call(this, data)) {
      return undefined;
    }
    return this.dm.media.vectorImage.getSvgInfoFromCache(data.uri);
  }
}
function _hasUriProperty(data) {
  return data !== null && typeof data === 'object' && 'uri' in data;
}
//# sourceMappingURL=ExternalResolvedDataHandler.js.map